
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/month4",
      function () {
        return require("private-next-pages/month4/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/month4"])
      });
    }
  